export const NAV_PANEL_DEFAULT = 200;
export const NAV_PANEL_MIN = 200;
export const NAV_PANEL_MAX = 420;
const NAV_PANEL_COOKIE = "nav_panel_width";
const NAV_PANEL_MAX_AGE = 60 * 60 * 24 * 7;

export const readNavPanelWidth = (cookie: string) => {
  const match = cookie.match(/(?:^|; )nav_panel_width=(\d+)/);
  const width = Number(match?.[1]);
  if (
    !Number.isInteger(width) ||
    width < NAV_PANEL_MIN ||
    width > NAV_PANEL_MAX
  )
    return NAV_PANEL_DEFAULT;
  return width;
};

export const navPanelWidthCookie = (width: number) =>
  `${NAV_PANEL_COOKIE}=${width}; path=/; max-age=${NAV_PANEL_MAX_AGE}`;
